export default import.meta.ROLLDOWN_FILE_URL_Q6H46tiWD5KOWdRjlUA61w